module.exports = __webpack_public_path__ + "img/add_photo.105130cc.png";